import React from 'react';
import Hero from '../components/Hero';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
    </>
  );
};

export default HomePage;
